'use client';
import React from 'react';
import Link from 'next/link';
import { LayoutDashboard, FolderKanban, CreditCard, Wallet, FileBarChart, Banknote } from 'lucide-react';

interface BottomNavProps {
  activeRoute: string;
}

const bottomNavItems = [
  { href: '/', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
  { href: '/master-project-management', label: 'Proyek', icon: <FolderKanban size={20} /> },
  { href: '/hutang-management', label: 'Hutang', icon: <CreditCard size={20} /> },
  { href: '/pembayaran-hutang', label: 'Pembayaran', icon: <Banknote size={20} /> },
  { href: '/piutang-management', label: 'Piutang', icon: <Wallet size={20} /> },
  { href: '/laporan', label: 'Laporan', icon: <FileBarChart size={20} /> },
];

export default function BottomNav({ activeRoute }: BottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-modal">
      <ul className="flex items-center justify-around px-1 py-1">
        {bottomNavItems.map((item) => {
          const isActive = activeRoute === item.href;
          return (
            <li key={`bottom-${item.href}`}>
              <Link
                href={item.href}
                className={`flex flex-col items-center gap-0.5 px-2 py-2 rounded-lg transition-all duration-150 min-w-[44px] ${
                  isActive
                    ? 'text-primary' :'text-muted-foreground hover:text-foreground'
                }`}
              >
                <span className={`transition-transform duration-150 ${isActive ? 'scale-110' : ''}`}>
                  {item.icon}
                </span>
                <span className={`text-[10px] font-500 ${isActive ? 'font-600' : ''}`}>{item.label}</span>
                {isActive && (
                  <span className="w-1 h-1 rounded-full bg-primary mt-0.5" />
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}